export default __webpack_public_path__ + "static/media/Minnikhanov_Rustam.cec2511f.webp";